/**
 * Formats a state code to include the country prefix for province code.
 * Matches the server-side implementation in PatientProfileService.ts
 * @param state - The state code (e.g., "CA", "NY")
 * @returns Formatted province code (e.g., "US-CA", "US-NY")
 */
export const formatProvinceCode = (state: string): string => {
  const countryForProvinceCode = "US-";
  return countryForProvinceCode + state;
};
